import { useEffect, useState } from "react";
import { HexGroupI } from "@/types/base";
import { getHexgroupsByLocation } from "@/api/base";
import { useLocationStore } from "@/store/userPosition";

export function useHexGroupByLocation() {
  const location = useLocationStore((s) => s.location);
  const { latitude, longitude } = location || {};
  const [
    hexGroupByLocation,
    setHexGroupByLocation,
  ] = useState<HexGroupI | null>(null);
  const [hexGroupByLocationLoading, setHexGroupByLocationLoading] = useState(
    false
  );

  useEffect(() => {
    if (!location) return;
    if (latitude === undefined || longitude === undefined) return;
    if (hexGroupByLocation) return;
    setHexGroupByLocationLoading(true);
    (async () => {
      try {
        const res = await getHexgroupsByLocation({
          lon: longitude,
          lat: latitude,
        });
        setHexGroupByLocation(res);
        setHexGroupByLocationLoading(false);
      } catch (e) {
        //
      } finally {
        setHexGroupByLocationLoading(false);
      }
    })();
  }, [longitude, latitude, hexGroupByLocation]);

  return { hexGroupByLocation, hexGroupByLocationLoading } as const;
}
